import { AdjustmentReasonMiniEntity } from '../../domain/entities/AdjustmentReasonMiniEntity'

export class AdjustmentReasonMiniModel extends AdjustmentReasonMiniEntity {
  constructor(dataDto: { adjustmentReasonId?: number; reason?: string | null }) {
    super()
    this.id = dataDto.adjustmentReasonId
    this.name = dataDto.reason
  }
}
